import { render, staticRenderFns } from "./SessaoExpirandoDialog.vue?vue&type=template&id=8b46e01a"
import script from "./SessaoExpirandoDialog.vue?vue&type=script&lang=js"
export * from "./SessaoExpirandoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports